import React from 'react'
import './styles.css'

const EmailHelperText = () => (
  <div className="emailHelperText">
    <p>
      The <span>@thumbs_up_thumbs_down</span> tag allows you to include these
      two buttons in an email.
    </p>
    <div>
      <img src="/images/thumbs-up.svg" alt="Thumbs Up" />
      <img src="/images/thumbs-down.svg" alt="Thumbs Down" />
    </div>
    <p>
      The <span>@stars</span> tag allows you to include these stars in an email.
    </p>
    <div>
      <img src="/images/stars.svg" alt="Stars" />
    </div>
    <p>
      Patients that submit a post-appointment survey using either method will be
      brought to a new page that will have links to your location's social pages
      (Facebook, Google, and Yelp) if you provide links for them above.
    </p>
    {!process.env.REACT_APP_IS_TOPS && (
      <p>
        Additionally, this page will contain a comment box where patients can
        submit comments that are viewable from the patient's page or the Reviews
        tab of the Dashboard.
      </p>
    )}
    <p>
      Each social link is available to use in the message if you'd prefer those
      to the thumbs up/down or stars. Note that no responses or comments can be
      recorded without the thumbs up/down or stars.
    </p>
    <p style={{ fontWeight: '600' }}>
      Note: one of the following must be included in this template for emails to
      function correctly
    </p>
    <ul>
      <li>
        <span>@thumbs_up_thumbs_down</span>
      </li>
      <li>
        <span>@stars</span>
      </li>
      <li>
        <span>@location_facebook_url</span>
      </li>
      <li>
        <span>@location_google_url</span>
      </li>
      <li>
        <span>@location_yelp_url</span>
      </li>
    </ul>
  </div>
)

export default EmailHelperText



// WEBPACK FOOTER //
// ./src/components/Settings/PostApptReviewMessageEditor/EmailHelperText.js